import { getRequest, putRequest } from "./httpClient";

const END_POINT_ACCESS = "userAccess";

const getProfile = async () => {
  //console.log("user.api, getProfile: ");
  let errorResponse = undefined;
  const response = await getRequest(`${END_POINT_ACCESS}/profile`);
};

const setCurrentUser = async () => {
  console.log("***************user.api, setCurrentUser");
  return await putRequest(`${END_POINT_ACCESS}/current`);
};

const setCurrentProject = async (partyReference) => {
  const response = await putRequest(`${END_POINT_ACCESS}/project/${partyReference}`);
  console.log("user.api, setCurrentProject, response: ", response);
  return response;
};

export { getProfile, setCurrentUser, setCurrentProject };
